import { NgModule } from '@angular/core';

import { OverviewContainerComponent } from './overview.container';

import { ChartsModule } from '../../shared/charts/charts.module';
import { SharedModule } from '../../shared/shared.module';
import { EffectsModule } from '@ngrx/effects';
import { OverviewEffects } from './overview.effects';
import { CommonModule, DecimalPipe } from '@angular/common';
import { RouterModule } from '@angular/router';
import { PipesModule } from '../../global/pipes/pipes.module';
import { IconModule } from 'atlas-icon';
import { ButtonModule } from 'atlas-button';
import { LegacyModule } from 'atlas-legacy';
import { TableModule } from 'atlas-table';
import { CdkModule } from 'atlas-cdk';
import { SwitchModule } from 'atlas-switch';
import { TooltipModule } from 'atlas-tooltip';
import { PaginationModule } from 'atlas-pagination';
import { MenuModule } from 'atlas-menu';
import { ListModule } from 'atlas-list';
import { LinkModule } from 'atlas-link';
export const COMPONENTS = [
  OverviewContainerComponent
];

@NgModule({
  declarations: COMPONENTS,
  imports: [
    // // MercerOSModule,
    SharedModule,
    ChartsModule,
    CommonModule,
    RouterModule,
    PipesModule,
    IconModule,
    ButtonModule,
    LegacyModule,
    TableModule,
    CdkModule,
    SwitchModule,
    TooltipModule,
    PaginationModule,
    MenuModule,
    ListModule,
    LinkModule,
    EffectsModule.forFeature([OverviewEffects])
  ],
  exports: COMPONENTS,
  providers: [DecimalPipe],
  bootstrap: [],
})
export class OverviewModule {
}
